import type { LensCardType, LensCardView, LensDatasetColumn } from '~/types/leLens';

/** Named table measures keep their ordered aliases; their governed operands supply the arithmetic. */
export function namedTableRatios(
  view: LensCardView | undefined,
  type: LensCardType | undefined,
  columns: ReadonlyArray<LensDatasetColumn> = [],
): Array<LensDatasetColumn & { ratio: { of: string; per: string } }> {
  if (type !== 'table' || !view || view.ratio) return [];
  const selected = new Set([view.value, ...(view.values ?? [])]);
  return columns.filter(
    (column): column is LensDatasetColumn & { ratio: { of: string; per: string } } =>
      selected.has(column.name) && Boolean(column.ratio),
  );
}

/** Virtual ratio aliases need both physical inputs, even when a query also returns the alias. */
export function tableMeasureInputs(
  view: LensCardView,
  type: LensCardType | undefined,
  columns: ReadonlyArray<LensDatasetColumn> = [],
): Array<string> {
  const ratios = new Map(namedTableRatios(view, type, columns).map((column) => [column.name, column.ratio]));
  return [
    ...new Set(
      [view.value, ...(view.values ?? [])].flatMap((name) => {
        if (!name) return [];
        const ratio = ratios.get(name);
        return ratio ? [ratio.of, ratio.per] : [name];
      }),
    ),
  ];
}
